<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-card
          class="rounded-lg d-flex justify-center align-center"
          min-height="390px"
          min-width="200px"
          v-on="on"
          @click="addShooting"
        >
          <v-avatar color="primary" size="70">
            <v-icon size="70" color="white">add</v-icon>
          </v-avatar>
        </v-card>
      </template>
      <span>{{ $t('shootings.addShooting') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'AddShooting',
  methods: {
    addShooting() {
      this.$router.push('/shootings/create')
    }
  }
}
</script>
